import { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { api } from '../../lib/api';
import { useToast } from '../../context/ToastContext';
import FormEmpresa from './FormEmpresa';

// Admin da imobiliária (nivel 2) editando a PRÓPRIA empresa — antes só o
// superadmin tinha tela de empresa (menu "Empresas", nivel 1). A API já tinha
// `GET /api/empresas/me`; aqui só faltava a tela. Só cadastro, endereço e
// marketing (ver `abasParaAdmin`); plano/limites/financeiro continuam do
// superadmin, e o backend descarta esses campos mesmo que alguém os envie.
export default function MinhaEmpresa() {
  const toast = useToast();
  const [empresa, setEmpresa] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    api
      .get('/empresas/me')
      .then((r) => setEmpresa(r.data))
      .catch((err) => {
        setErro(true);
        toast.erro(err.message || 'Não foi possível carregar sua empresa');
      })
      .finally(() => setCarregando(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function salvar(dados) {
    const r = await api.put(`/empresas/${empresa.public_id}`, dados);
    setEmpresa(r.data);
    toast.sucesso('Dados da empresa atualizados com sucesso.');
  }

  return (
    <>
      <h1 className="h4 mb-4">Minha empresa</h1>
      {carregando ? (
        <Spinner animation="border" />
      ) : (
        !erro && <FormEmpresa restrito empresaInicial={empresa} aoSalvar={salvar} />
      )}
    </>
  );
}
